import { Loader, LogoLoader } from "@bcc-ui/ui-components";
import classNames from "classnames";
import * as React from "react";

import style from "./loading-indicator.scss";

import testIds from "testIds.json";

export const LoadingIndicator = (props: {
    small?: boolean;
    smaller?: boolean;
    isWhite?: boolean;
    isView?: boolean;
    withTable?: boolean;
    className?: string;
}): JSX.Element => {
    if (props.small) {
        return (
            <div className={classNames({ [style.withTable]: props.withTable }, style.smallGrid)}>
                <Loader testId={testIds.common.inProgressElement} white={props.isWhite} />
            </div>
        );
    }

    if (props.smaller) {
        return <Loader small testId={testIds.common.inProgressElement} white={props.isWhite} />;
    }

    if (props.isView) {
        return (
            <div className={style.logoLoaderViewContainer}>
                <div className={classNames(style.logoLoader)}>
                    <LogoLoader testId={testIds.common.inProgressElement} />
                </div>
            </div>
        );
    }

    return (
        <div className={classNames(style.skCubeGrid, props.className)}>
            <LogoLoader testId={testIds.common.inProgressElement} />
        </div>
    );
};
